// extracted by mini-css-extract-plugin
module.exports = {"default":"ntyIj0_3S5Pla8_L7Afws button","success":"_8D31n9-_Y7etisx2KT94_ button success","primary":"_1Qh-IyNUezeya5W-LyHlbE button primary","danger":"_2MrrMR_ueVegaHOBSwjayf"};